import _ from "lodash"

const organizationTypeByCode = {
    AA: 'association',
    AS: 'association',
    FO: 'supplier',
    IN: 'internal'
}

function migrateZipCodes(broadcastList, set) {
    set.establishmentZipCode = broadcastList.shelterZipCode ?? null
    set.shelterZipCode = null
    set.organizationZipCode = broadcastList.zipCodes ?? null
}

function migrateContact(broadcastList, set) {
    set.contactFunction = broadcastList.functions || []
    set.contactProfile = broadcastList.profiles || []
    set.organizationContributionsStatus = broadcastList.contributionsStatus ?? null
}

function migrateOrganizationType(broadcastList, organizationTypeCodeById, set) {
    const codes = (broadcastList.organizationTypes || [])
        .map(id => organizationTypeCodeById.get(id.toString()))
        .filter(Boolean)

    if (!codes.length) return

    const newOrganizationTypes = _.uniq(codes.map(code => organizationTypeByCode[code]).filter(Boolean))
    if (newOrganizationTypes.length) set.organizationType = newOrganizationTypes
    if (codes.includes('AA')) set.organizationStatus = ['member']
}

function buildUpdate(broadcastList, lookups) {
    const set = {}
    migrateZipCodes(broadcastList, set)
    migrateContact(broadcastList, set)
    migrateOrganizationType(broadcastList, lookups.organizationTypeCodeById, set)
    return set
}

async function applyJob() {
    const collection = global.app.C.BroadcastListPlatform.collection
    const organizationTypeCollection = global.app.C.OrganizationType.collection

    const [broadcastLists, organizationTypes] = await Promise.all([
        collection.find({}).toArray(),
        organizationTypeCollection.find({}).toArray()
    ])

    const organizationTypeCodeById = new Map(organizationTypes.map(type => [type._id.toString(), type.code]))

    const operations = broadcastLists.map(broadcastList => ({
        updateOne: {
            filter: {_id: broadcastList._id},
            update: {$set: buildUpdate(broadcastList, {organizationTypeCodeById})}
        }
    }))

    if (!operations.length) return {message: "Aucune liste de diffusion à adapter"}

    const result = await collection.bulkWrite(operations)
    return {message: `${result.modifiedCount} liste(s) de diffusion adaptée(s) sur ${broadcastLists.length}`}
}

export const job = {
    name: "adaptBroadcastListPlatformCollection",
    title: "Adapter la collection BroadcastListPlatform au nouveau modèle",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
